/**
 * 工具模組統一入口
 * 提供模組化、解耦的工具執行架構
 */

// 導入工具定義
export {
  TOOL_TYPES,
  SCAFFOLD_TOOLS,
  RESOURCE_TOOLS,
  ALL_TOOLS,
  getToolById,
  getToolsByType,
} from './toolDefinitions';

// 導入鷹架工具執行器
export { executeScaffoldTool } from './scaffoldTools';

// 導入資源工具執行器
export { executeResourceTool } from './resourceTools';

/**
 * 統一的工具執行入口
 * @param {Object} tool - 工具配置對象
 * @param {Object} params - 執行參數
 * @param {Array} params.nodeContents - 節點內容（鷹架工具使用）
 * @param {string} params.userInput - 用戶輸入（資源工具使用）
 * @returns {Promise<string>} HTML 結果字符串
 */
export const executeTool = async (tool, params = {}) => {
  const { nodeContents, userInput } = params;
  
  // 根據工具類型路由到對應的執行器
  if (tool.type === 'scaffold') {
    const { executeScaffoldTool } = await import('./scaffoldTools');
    return executeScaffoldTool(tool.id, nodeContents);
  } else if (tool.type === 'resource') {
    const { executeResourceTool } = await import('./resourceTools');
    return await executeResourceTool(tool.id, userInput);
  } else {
    throw new Error(`未知的工具類型: ${tool.type}`);
  }
};
